var _require = require('react'),
    useEffect = _require.useEffect;

var _require2 = require('./keys.js'),
    onKeyPress = _require2.onKeyPress,
    convertToAsciiEquivalent = _require2.convertToAsciiEquivalent,
    getAsciiCode = _require2.getAsciiCode;

var useKey = function useKey(callback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$detectKeys = _ref.detectKeys,
      detectKeys = _ref$detectKeys === void 0 ? [] : _ref$detectKeys;

  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$dependencies = _ref2.dependencies,
      dependencies = _ref2$dependencies === void 0 ? [] : _ref2$dependencies;

  var allowedKeys = detectKeys;

  if (!window || !window.document || !callback) {
    throw new Error();
  }

  if (!Array.isArray(dependencies)) {
    throw new Error(typeof dependencies);
  }

  if (!Array.isArray(detectKeys)) {
    allowedKeys = [];
    console.warn('Keys should be array!');
  }

  allowedKeys = convertToAsciiEquivalent(allowedKeys);
  useEffect(function () {
    window.document.addEventListener('keydown', function (event) {
      return onKeyPress(getAsciiCode(event), callback, allowedKeys);
    });
    return function () {
      window.document.removeEventListener('keydown', onKeyPress);
    };
  }, dependencies);
};

module.exports = useKey;